export const INIT = 'STUDENTS/INIT';

export const GET_DATA_START = 'STUDENTS/GET_DATA_START';
export const GET_DATA_NEXT_PAGE_START = 'STUDENTS/GET_DATA_NEXT_PAGE_START';

export const COLUMNS_SAVE_USER_SETUP_START = 'STUDENTS/COLUMNS_SAVE_USER_SETUP_START';
/* Akcja służy informowaniu zakładki strona-przedmiotu o zmianie konfiguracji kolumn dla tabeli "Studenci" */
export const COLUMNS_SAVE_USER_SETUP_SUCCESS = 'STUDENTS/COLUMNS_SAVE_USER_SETUP_SUCCESS';

export const COLUMNS_GET_CONFIG_START = 'STUDENTS/COLUMNS_GET_CONFIG_START';

export const FILTERS_GET_CONFIG_START = 'STUDENTS/FILTERS_GET_CONFIG_START';
export const FILTERS_REFRESH_VALUES_START = 'STUDENTS/FILTERS_REFRESH_VALUES_START';

export const RECORD_GET_DETAILS_START = 'STUDENTS/RECORD_GET_DETAILS_START';

export const REFRESH_DATA_START = 'STUDENTS/REFRESH_DATA_START';
export const SYNC_DATA_WITH_CACHE_START = 'STUDENTS/SYNC_DATA_WITH_CACHE_START';